/* unplugin-vue-components disabled */export default defineComponent({
  name: 'ExternalContacts',
  components: {},
  setup: function setup() {
    return {};
  }
});